module.exports = __webpack_public_path__ + "static/img/26.38e1e6f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/26.png
// module id = IcB7
// module chunks = 1